import { render, staticRenderFns } from "./AgentChat.vue?vue&type=template&id=567240aa&scoped=true"
import script from "./AgentChat.vue?vue&type=script&lang=js"
export * from "./AgentChat.vue?vue&type=script&lang=js"
import style0 from "./AgentChat.vue?vue&type=style&index=0&id=567240aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567240aa",
  null
  
)

export default component.exports